import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import VendorHeader from "./../../component/VendorHeader";
import VendorFooter from "./../../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../component/Sidebar";

const deleteIcon = require("./../../assets/img/delete-icon.svg").default;

const AdminAnnouncements = () => {
    const { user } = useAuth();
    const { selectedLanguage, langJson } = useLanguage();
    const navigate = useNavigate();
    const actionDivRef = useRef(null);

    const [loading, setLoading] = useState();
    const [announcementList, setAnnouncementList] = useState([]);
    const [selectedId, setSelectedId] = useState();

    const fetchAnnouncements = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}stores/announcements`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user.authorisation.token}`,
                },
            });
            const responseData = await response.json();
            if (responseData.res === true) {
                setAnnouncementList(responseData.data);
            } else {
                console.error("Failed to fetch announcements");
            }
        } catch (error) {
            console.error("Error fetching announcements:", error);
            setLoading(false);
        }
    };

    const handleDelete = async announcementId => {
        if (announcementId) {
            const confirmDelete = window.confirm("Are you sure you want to delete this announcement?");

            if (confirmDelete) {
                try {
                    const response = await fetch(`${API_BASE_URL}stores/announcements/${announcementId}`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${user.authorisation.token}`,
                        },
                    });
                    const responseData = await response.json();
                    if (responseData.res === true) {
                        let tempArray = [...announcementList];
                        let selIndex = tempArray.findIndex(item => parseInt(item?.id) === parseInt(announcementId));
                        tempArray.splice(selIndex, 1);
                        setAnnouncementList(tempArray);
                        setSelectedId(null);
                    } else {
                        console.error("Failed to delete announcement");
                    }
                } catch (error) {
                    console.error("Error deleting announcement:", error);
                    setLoading(false);
                }
            }
        }
    };



    useEffect(() => {
        fetchAnnouncements();
    }, []);

    useEffect(() => {
        const handleClickOutside = event => {
            if (!actionDivRef?.current?.contains(event.target)) {
                // Clicked outside the td
            }
        };
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div>
            <div className="dashHeader">
                <VendorHeader />
            </div>
            <div className="adminDash">
                <Sidebar />

                <div className="rightSide rightTop">
                    <h2>{langJson?.announcements ?? 'Announcements'}</h2>
                    <div className="prdtTopRight">
                        <Link to="/admin/announcements/add">{langJson?.addnew ?? 'Add New'}</Link>
                    </div>
                    <div className="prdtTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>{langJson?.text ?? 'Text'}</th>

                                    <th>{langJson?.action ?? 'Action'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {announcementList?.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {item?.en || 'No text'}
                                        </td>

                                        <td className="actionHolder">
                                            <div className="actionDiv" ref={actionDivRef}>
                                                <button onClick={() => navigate(`/admin/announcements/edit/${item?.id}`)}>{langJson?.edit ?? 'Edit'}</button>
                                                <button onClick={() => handleDelete(item?.id)}>{langJson?.delete ?? 'Delete'}</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <VendorFooter />
        </div>
    );
};

export default AdminAnnouncements;
